<template>
  <div class="scs-spotify-track">
    <img
      :class="{
        'track-album': true,
        'no-print': true,
        'preview-unavailable': !track.album.preview_url,
      }"
      :src="track.album.images[track.album.images.length - 1].url"
      @click="play"
    />
    <div class="title-and-artist">
      <h5 class="track-name">{{ track.name }}</h5>
      <p class="track-artist">{{ artists }}</p>
    </div>

    <p class="track-time" v-if="!currentTime">{{ trackTime }}</p>
    <p class="track-time" v-if="currentTime">
      {{ `${currentTime}/${duration}` }}
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      audio: undefined,
      audioPlaying: false,
    };
  },
  computed: {
    trackTime() {
      let m = Math.floor(this.track.duration_ms / 60000);
      let s = Math.floor((this.track.duration_ms / 1000) % 60).toLocaleString(
        "en-US",
        { minimumIntegerDigits: 2 }
      );
      return `${m}:${s}`;
    },
    artists() {
      return this.track.artists.reduce((a, b, index) => {
        if (index !== 0) {
          return a + ", " + b.name;
        } else {
          return a.name;
        }
      }, this.track.artists[0]);
    },
  },
  methods: {
    play() {
      console.log(this.track);
      this.$store.commit("playAudio", this.track);
    },
  },
  created() {},
  components: {},
  props: ["track", "currentTime", "duration"],
};
</script>
<style scoped>
@media screen {
  .scs-spotify-track {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    /* max-width: 100%; */
    width: 300px;
    max-width: 100%;
    padding: 5px;
  }

  .track-name,
  .track-artist,
  .track-time {
    margin: 5px;
    text-align: left;

    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .title-and-artist {
    max-width: 60%;
  }

  .track-time {
    float: right;
    margin-left: auto;
  }

  .track-album {
    height: 45px;
    width: 45px;
    object-fit: cover;
    border-radius: 5px;
    margin-right: 10px;
  }
  .track-artist,
  .track-time {
    font-size: 0.75rem;
  }

  img {
    cursor: pointer;
  }
  @media (min-width: 800px) {
    .scs-spotify-track {
      max-width: 100%;
      width: 300px;
    }
  }
}
</style>
